import { render, staticRenderFns } from "./ExpensesTypesTable.vue?vue&type=template&id=beada116&"
import script from "./ExpensesTypesTable.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports